import React from 'react';
import { m as motion } from 'framer-motion';
import { Container } from './ui/Container';
import { SectionTag } from './ui/SectionTag';
import { CTAButton } from './ui/CTAButton';
import { methodSteps } from '../data/sections';
const easeOut: [number, number, number, number] = [0.23, 1, 0.32, 1];
export function MethodSection() {
  return <section className="bg-mp-dark py-16 md:py-24" data-id="element-198" data-mp="3uzuc1e9f11ds">
      <Container data-id="element-199" data-mp="vjfp47qjsglg">
        <div className="mx-auto max-w-[700px] text-center" data-id="element-200" data-mp="vhuu6h0bmvn2">
          <SectionTag tone="lime" data-id="element-201" data-mp="qk30bhg48zg8">El método "Ficha en Mano"</SectionTag>
          <h2 className="mt-5 font-heading text-3xl uppercase leading-tight text-mp-white sm:text-4xl" data-id="element-202" data-mp="qlw7qyyjznpa">
            Preparar tu clase puede ser así de sencillo.
          </h2>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 md:grid-cols-3" data-id="element-203" data-mp="hr97eh7qy1jw">
          {methodSteps.map((step, i) => <motion.div key={step.number} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.4,
          ease: easeOut,
          delay: i * 0.06
        }} className="rounded-2xl border border-mp-border bg-mp-card p-6" data-id="element-204" data-mp="1eb8g5wm23rqj" data-mpi={i}>
              <span className="flex h-10 w-10 items-center justify-center rounded-full border border-mp-lime/40 font-heading text-sm text-mp-lime" data-id="element-205" data-mp="1lbwa2lgv33fp">
                {step.number}
              </span>
              <p className="mt-4 font-heading text-lg uppercase tracking-wide text-mp-white" data-id="element-206" data-mp="1ca6d7047ncaj">{step.title}</p>
              <p className="mt-2 text-sm leading-relaxed text-mp-gray" data-id="element-207" data-mp="1hc5bvwp09l15">{step.copy}</p>
            </motion.div>)}
        </div>

        <div className="mt-10 text-center" data-id="element-208" data-mp="17ceglssmf200">
          <CTAButton href="#oferta" showArrow fullWidthMobile={false} data-id="element-209" data-mp="17d6exbdlrdtz">
            Quiero dejar de improvisar
          </CTAButton>
        </div>
      </Container>
    </section>;
}